import React, { useEffect, useState } from "react";
import { Card, Col, Row } from "react-bootstrap";
import PurchasedDrugsTable from "../components/tables/PurchasedDrugsTable";
import MedicationHistorySidebar from "../components/common/MedicationHistorySidebar";

export default function PurchasedDrugs({ loading, data }) {
  const currentSkin = localStorage.getItem("skin-mode") ? "dark" : "";
  const [skin, setSkin] = useState(currentSkin);

  const switchSkin = (mode) => {
    if (mode === "dark") {
      const btnWhite = document.getElementsByClassName("btn-white");

      for (const btn of btnWhite) {
        btn.classList.add("btn-outline-primary");
        btn.classList.remove("btn-white");
      }
      return;
    }

    const btnOutlinePrimary = document.getElementsByClassName("btn-outline-primary");

    for (const btn of btnOutlinePrimary) {
      btn.classList.remove("btn-outline-primary");
      btn.classList.add("btn-white");
    }
  };

  switchSkin(skin);
  useEffect(() => {
    switchSkin(skin);
  }, [skin]);

  const purchasedCount = Array.isArray(data) ? data.length : 0;
  const completedCount = Array.isArray(data) ? data.filter((item) => item?.status === 1).length : 0;
  const pendingCount = Array.isArray(data) ? data.filter((item) => item?.status === 0).length : 0;

  return (
    <React.Fragment>
      <div className=" p-3 p-lg-4">
        <div className="data-page-hero">
          <div className="data-page-copy">
            <span className="data-page-kicker">Pharmacy History</span>
            <h2>Review purchased medications more clearly</h2>
            <p>
              Browse your processed drug orders, compare statuses, and revisit details from
              a cleaner medications history page.
            </p>
          </div>

          <div className="data-page-stats">
            <div className="data-page-stat">
              <small>Total Orders</small>
              <strong>{purchasedCount}</strong>
            </div>
            <div className="data-page-stat">
              <small>Completed</small>
              <strong>{completedCount}</strong>
            </div>
            <div className="data-page-stat">
              <small>Pending</small>
              <strong>{pendingCount}</strong>
            </div>
          </div>
        </div>

        <Row className="g-4">
          <Col xl="9">
            <Card className="data-panel">
              <PurchasedDrugsTable data={data} loading={loading} />
            </Card>
          </Col>

          <Col xl="3" className="d-none d-xl-block">
            <MedicationHistorySidebar />
          </Col>
        </Row>
      </div>
    </React.Fragment>
  );
}
